import { getObjectValueByPath } from '@/helpers/common/helper'

export default {
  computed: {
    locale() {
      return this.$i18n?.locale
    },
  },
  methods: {
    getLocaleMessage(path) {
      const messages = this.$i18n?.getLocaleMessage(this.locale)
      return getObjectValueByPath(messages, path)
    },
  },
}
